import { useTranslation } from "react-i18next";

import styled from "styled-components";

import type { OpenAPI } from "simplydo/interfaces";
import { Label, Message, Segment } from "simplydo/react/ui";

export const StyledSegment = styled(Segment)`
  ${({ $isAssessment, theme }) =>
    $isAssessment ?
      `
    border: none !important;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${theme.colorMap.violet} !important;
    h3 {
      margin: 0;
      padding: 0;
    }
  `
    : ""}
`;

type SectionHeaderProps = {
  section: NonNullable<OpenAPI.Schemas["IdeaTemplate"]["body"]>[number];
  assessment?: NonNullable<OpenAPI.Schemas["Idea"]["assessments"]>[number];
  canViewEdi: boolean;
  canEdit: boolean;
  isAuthor: boolean;
  isAssessor?: boolean;
};

const SectionHeader = ({
  section,
  assessment,
  canViewEdi,
  canEdit,
  isAuthor,
  isAssessor,
}: SectionHeaderProps) => {
  const { t } = useTranslation();

  const hasAssessmentScore = (fieldId: string) => {
    const score = assessment?.assessment?.[fieldId]?.score;
    if (score === undefined || score === null) {
      return false;
    }
    if (typeof score === "string") {
      return score !== "";
    }
    return true;
  };

  return (
    <StyledSegment attached="top" $isAssessment={section.type === "assessment"}>
      <h3>{section.name}</h3>
      {isAssessor && section.type === "assessment" ?
        <Label
          active
          color={
            (
              section.fields.filter((field) => hasAssessmentScore(field.id))
                .length ===
              section.fields.filter((field) => field.type === "assessment")
                .length
            ) ?
              "green"
            : undefined
          }
        >
          Assessed{" "}
          {
            section.fields.filter((field) => hasAssessmentScore(field.id))
              .length
          }{" "}
          /{" "}
          {section.fields.filter((field) => field.type === "assessment").length}
        </Label>
      : null}

      {section.type === "edi" ?
        !isAuthor && !canViewEdi && canEdit ?
          <Message warning>
            <Message.Header>EDI privacy notice</Message.Header>
            <Message.Content>
              {t("ideas.edi.header")}. Its content is hidden because you do not
              have permissions to view or edit the information in this section.
              For privacy reasons, only {t("generic.idea")} authors and
              administrators can see this data. If you believe you should have
              access, please contact your organisation's administrator.
            </Message.Content>
          </Message>
        : <Message success>
            <Message.Header>{t("ideas.edi.header")}</Message.Header>
            <Message.Content>{t("ideas.edi.info")}</Message.Content>
          </Message>

      : null}
    </StyledSegment>
  );
};

export default SectionHeader;
